import { get } from 'http';
import {
    AUTH_APP_URL,
    AUTH_REDIRECT_URL,
    AUTH_UI_APP_DISABLED,
} from '../core/CcxEnv';
import { getLocalStorage } from '../core/helpers';

export type RequestProps = {
    data?: object;
    redirect?: boolean;
    version?: number;
};

export default class ApiService {
    // protected static async request(
    //   path: string,
    //   method: string,
    //   props?: RequestProps
    // ): Promise<any> {}

    protected static getApiUrl(version?: number): string | void {}
    /**
     * Send request to backend
     */
    protected static async request(
        method: string,
        path: string,
        props?: RequestProps
    ): Promise<any> {
        let responseData;
        const { id, type } = getLocalStorage('org');
        const headers: HeadersInit = {};

        if (id && type) {
            headers['CCX-Owner'] = `${type}:${id}`;
        }

        const response = await fetch(
            `${this.getApiUrl(props?.version)}/${path}`,
            {
                headers,
                method,
                credentials: 'include',
                body: props?.data ? JSON.stringify(props?.data) : null,
            }
        );

        if (response.status === 401) {
            try {
                responseData = await response.json();
                if (!responseData.admin) {
                    if (AUTH_REDIRECT_URL) {
                        window.location.href = AUTH_REDIRECT_URL;
                    } else if (AUTH_UI_APP_DISABLED) {
                        window.location.href = AUTH_APP_URL;
                    } else {
                        window.location.href = `${AUTH_APP_URL}/?redirectTo=${encodeURIComponent(
                            window.location.href
                        )}`;
                    }
                }
            } catch (err) {
                responseData = null;
            }
        }

        try {
            responseData = await response.json();
        } catch (err) {
            responseData = null;
        }

        if (!response.ok) {
            const errorMessage = responseData?.err || response.statusText;
            let error = undefined;
            if (
                responseData.error_fields &&
                responseData.error_fields.length > 0
            ) {
                error = {
                    message: errorMessage,
                    errorFields: responseData.error_fields,
                };
            }
            if (error) {
                throw error;
            }
            throw new Error(errorMessage);
        }

        return responseData;
    }
}
